<template>
  <div class="guideVideoBg">
    <div class="tip">
      <i></i>
      <p>新手指引</p>
    </div>
    <ul>
      <li class="video-li wow fadeInUp" v-for="(v, index) in list" :key="index" :data-wow-delay="`0.${(index+1)^index*5}s`">
        <p><span>STEP{{index + 1}}</span>{{v.name}}</p>
        <div class="content" @click="showVideo(index)">
          <div class="bg" :style="`background-image: url(${imgUrl('home/' + (index+1) + '.jpg')})`"></div>
          <i class="btn"></i>
        </div>
      </li>
    </ul>

    <div class="videoFixedBg" v-if="isShow">
      <div class="pr">
        <video :src="list[index].url" autoplay controls width="800" height="600"></video>
        <i class="close" @click="isShow = false"><Icon type="md-close" /></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [
        { name: '账户开立', url: 'https://uat.oss.rzline.com/common/video/ktb/guide_ktb_apply_acct.mp4' },
        { name: '银行签约', url: 'https://uat.oss.rzline.com/common/video/ktb/guide_ktb_credit.mp4' },
        { name: '在线贴现', url: 'https://uat.oss.rzline.com/common/video/ktb/guide_ktb_discount.mp4' }
      ],
      index: 0,
      isShow: false
    }
  },
  mounted () {
    if (!this.isIE()) {
      new this.WOW().init();
    }
  },
  methods: {
    showVideo (index) {
      this.index = index
      this.isShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.guideVideoBg {
  margin-top: 48px;
  height: 250px;
  background: #ffffff;
  box-shadow: 0px 7px 12px 0px rgba(0, 0, 0, 0.11);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px;

  .tip {
    width: 214px;
    text-align: center;
    font-size: 18px;
    line-height: 27px;
    font-weight: bold;

    i {
      display: inline-block;
      width: 76px;
      height: 76px;
      background: url('~@/assets/img/home/icon_xinshouzhiyin.png');
    }
  }

  ul {
    flex: 1;
    display: flex;
    justify-content: space-between;

    .video-li {
      padding: 19px 0px 24px;

      p {
        font-size: 18px;
        line-height: 25px;
        margin-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: 800;
          color: #333333;
          line-height: 21px;
          border-bottom: 4px solid #e1241a;
          margin-right: 12px;
        }
      }

      .content {
        width: 304px;
        height: 170px;
        overflow: hidden;
        position: relative;
        border-radius: 9px;
        cursor: pointer;

        &:hover .bg {
          transform: scale(1.1);
          transition: all 1s;
        }

        .bg {
          width: 100%;
          height: 100%;
          background: url('~@/assets/img/home/TV.png');
          background-size: cover;
        }
        .iStyle {
          display: inline-block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .btn {
          .iStyle;
          width: 64px;
          height: 64px;
          background: rgba(255, 255, 255, 0.59);
          border-radius: 50%;

          &:after {
            .iStyle;
            content: '';
            width: 0;
            height: 0;
            margin-left: 2px;
            border-left: 27px solid #e1241a;
            border-top: 18px solid transparent;
            border-bottom: 18px solid transparent;
            border-radius: 2px;
          }
        }
      }
    }
  }
}
.videoFixedBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999999;
  display: flex;
  justify-content: center;
  align-items: center;

  video {
    background: #000;
  }

  .close {
    display: inline-block;
    width: 30px;
    height: 30px;
    position: absolute;
    top: -15px;
    right: -15px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/GuideVideo.vue